// extracted by mini-css-extract-plugin
export default {"MapPopup":"Map_MapPopup__7ZNvF"};